import {type FC, Fragment} from 'react';
import {COLUMN_CRUMB, HOME_CRUMB} from '../../../../../config/constants/crumb';
import {HOME} from '../../../../../config/constants/routes';
import type {ColumnListItemType} from '../../../../../core/entities/columns/schema';
import type {RankingMetric} from '../../../../../core/repositories/columnRepository';
import {SpTopBottomBanner} from '../../../../../shared/components/Banner/SpTopBottomBanner';
import type {Breadcrumb} from '../../../../../shared/components/BreadcrumbsComponent';
import {Card} from '../Card';
import {Header} from '../Header';
import {RANKING_METRIC_MAP} from '../constants';
import {COLUMNS_RANKING, COLUMNS_TOP} from '../routes';

type Props = {
  metric: RankingMetric;
  columns: ColumnListItemType[];
};
export const ColumnRankingPage: FC<Props> = ({metric, columns}) => {
  const title = `コラム ${RANKING_METRIC_MAP[metric]}ランキング`;
  const breadcrumbs: Breadcrumb[] = [
    {label: HOME_CRUMB, href: HOME},
    {label: COLUMN_CRUMB, href: COLUMNS_TOP},
    {
      label: `${RANKING_METRIC_MAP[metric]}ランキング`,
      href: COLUMNS_RANKING(metric),
    },
  ];

  return (
    <>
      <Header breadcrumbs={breadcrumbs} title={title} />
      <div className="w-full pc:w-[1200px] pc:mx-auto grid grid-cols-1 pc:grid-cols-3 mt-12 p-16 pc:px-0 gap-16 pc:gap-24">
        {columns.map((column, index) => (
          <Fragment key={column.id}>
            <Card
              id={column.id}
              title={column.title}
              clipCount={column.favoriteCount}
              isClipped={column.favorited}
              tagNames={column.tags}
              thumbnail={column.cardImageURL ?? column.carouselThumbnailURL}
              className="w-full"
              sponsoredOption={{enabled: false}}
              updatedAt={column.updateDateTime}
            />
            {index === 0 && (
              <div className="w-full flex pc:hidden justify-center pt-8 pb-16">
                <SpTopBottomBanner type="top" />
              </div>
            )}
            {index === 2 && (
              <div className="w-full flex pc:hidden justify-center pt-8 pb-16">
                <SpTopBottomBanner type="bottom" />
              </div>
            )}
          </Fragment>
        ))}
      </div>
    </>
  );
};
